import React, { createContext, useContext, useEffect, useState } from "react";
import axiosClient from "../config/axios";

// Crear contexto
const OrderVialContext = createContext();

// Valores fijos
const ORDER_STATUSES = ["Pendiente", "Pagado", "Cancelado" ];

const ORDER_STATES_FILTER = [
  { value: "Cancelado", label: "Canceladas" },
  { value: "Activo", label: "Activas" },
];

export const OrderVialProvider = ({ children }) => {
  const [serviceTypes, setServiceTypes] = useState([]);

  // useEffect(() => {
  //   axiosClient
  //     .get("/typeServices/datatable")
  //     .then((response) => {
  //       const options = response.data.data.map((item) => ({
  //         value: item.id,
  //         label: item.type_service_name,
  //       }));
  //       setServiceTypes(options);
  //     })
  //     .catch((error) => {
  //       console.error("Error al obtener tipos de servicio:", error);
  //     });
  // }, []);

  return (
    <OrderVialContext.Provider
      value={{
        orderStatuses: ORDER_STATUSES,
        orderStatesFilter: ORDER_STATES_FILTER,
        serviceTypes,
      }}
    >
      {children}
    </OrderVialContext.Provider>
  );
};

// Hook para consumir el contexto
export const useOrderVialContext = () => {
  return useContext(OrderVialContext);
};
